import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetDatasourceNlpSettingParams {
  id: string;
  nlpOption: string;
  askDataFeedbackToCuratorEnabled?: boolean;
}

export class SetDatasourceNlpSettingRequest extends Request<ISetDatasourceNlpSettingParams, IEmptyResult> {
  constructor(params: ISetDatasourceNlpSettingParams) {
    super('setDatasourceNlpSetting', params);
  }
}
